module.exports = __webpack_public_path__ + "img/low_report.62c80cfa.png";